// extracted by mini-css-extract-plugin
export default {"embedYoutube":"index-module--embedYoutube--P7a2J","embedYoutubePlay":"index-module--embedYoutubePlay--3uJwv"};